import React from 'react'

const AccountOrder = () => {
  return (
    <div className="account-order">
        <h1>Rendelések</h1>
        <div className="account-order-container">
            <div className="account-order-item">
                <h2>Rendelés ID</h2>
                <p>2024.01.01</p>
                <p>2024.01.01</p>
                <p>2024.01.01</p>
            </div>
        </div>
    </div>
  )
}

export default AccountOrder